<template>
  <div class="row">
    <GenericProps
      :node-id="node.id"
      :settings.sync="settings"
      :audio-parameters="audioParameters"
      :parameters="node.parameters"
      @update:settings="updateNodeParent"
    />
  </div>
</template>

<script>
import { merge } from 'lodash';
import {
  getFieldError,
  createSettingsHierarchy,
} from '../../../../helpers/node';

import nodePropsMixin from '@/modules/ivrs/mixins/nodePropsMixin';

export default {
  name: 'PlayNode',

  mixins: [nodePropsMixin],

  data() {
    return {
      audioParameters: Object.freeze(['message'])
    };
  },

  watch: {
    node() {
      this.buildNodeSettings();
    },
  },

  created() {
    this.buildNodeSettings();
  },

  methods: {
    getFieldError,
    
    buildNodeSettings() {
      // Sets value of settings data
      this.settings = createSettingsHierarchy(this.node, undefined, undefined, this.node.settings);

      // Merges built settings hierarchy with current node settings
      this.settings = merge(this.settings.root, this.node.settings);

      this.handleMessage(this.settings.message);

      this.updateNodeParent();
    },
    handleMessage(settings) {
      if (settings.play.URL) {
        settings.isEnabled = true;
        settings.play.isEnabled = true;
      }
      if (settings.say.text) {
        settings.isEnabled = true;
        settings.say.isEnabled = true;
      }
    },
  },
};
</script>

<style>

</style>